import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import '../style/login.css'
import { API_URLS } from '@/src/constants/apis'

export default function LoginPage() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState('')
  const [error, setError] = useState('')
  const router = useRouter()

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await fetch(API_URLS.CHECK_AUTH, {
          credentials: 'include',
        })

        if (res.ok) {
          // router.replace('/langai/playground/1');
          window.location.href = '/langai/playground/1'
        }
      } catch (err) {
        // Do Nothing
      }
    }

    checkAuth()
  }, [])

  const handleLogin = async () => {
    const res = await fetch(API_URLS.LOGIN, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
      credentials: 'include',
    })

    if (res.ok) {
      window.location.href = '/langai/playground/1'
      // router.push('/langai/playground/1')
    } else {
      // const data = await res.json();
      setError('아이디 또는 비밀번호가 올바르지 않습니다.')
    }
  }

  const handleClearUsername = () => {
    setUsername('')
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleLogin()
    }
  }

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev)
  }

  return (
    <div id="wrapper">
      <main id="container">
        <section className="contents">
          <header className="membership_header ">
            <h2>JoongAng AI</h2>
            <h1 className="">로그인</h1>
            <div className="info_m ">
              Oslo(오슬로)를 더 안전하고 편리하게 이용하세요.
            </div>
          </header>
          <form className="form" action="">
            <div className="input_group">
              <input
                className="form_control"
                type="text"
                name=""
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="ID를 입력하세요"
                title=""
              />
              <button
                type="button"
                className="btn btn_x"
                aria-label="취소버튼"
                onClick={handleClearUsername}
              >
                <i className="ico_x"></i>
              </button>
            </div>
            <div className="input_group">
              <input
                className="form_control"
                type={showPassword ? 'text' : 'password'}
                name=""
                onChange={(e) => setPassword(e.target.value)}
                placeholder="비밀번호를 입력하세요"
                title=""
                onKeyDown={handleKeyPress}
              />
              <button
                type="button"
                className="btn btn_eye"
                aria-label="패스워드 확인"
                onClick={togglePasswordVisibility}
              >
                <i className={`ico_eye ${showPassword ? 'active' : ''}`}></i>
              </button>
            </div>
            <p className={`error font_primary ${error ? '' : 'hide'}`}>
              아이디 또는 비밀번호가 올바르지 않습니다. 다시 확인해 주세요.
            </p>
            <div className="form_check">
              <a href="" className="hide">비밀번호 찾기</a>
            </div>
            <div className="btn_group">
              <button
                type="button"
                className="btn btn_black"
                onClick={handleLogin}
              >
                로그인
              </button>
            </div>
          </form>
          <div className="join_email_link hide">
            <a href="">회원가입</a>
            <a href="">아이디 찾기</a>
          </div>
        </section>
      </main>
    </div>
  )
}
